(function() {
    'use strict';
    angular
        .module('publicGatewayApp')
        .factory('ProfileCriterionItem', ProfileCriterionItem);

    ProfileCriterionItem.$inject = ['$resource'];

    function ProfileCriterionItem ($resource) {
        var resourceUrl =  'api/profile-criterion-items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
